/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host([disabled]) {
  cursor: default;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--calcite-opacity-disabled);
}

:host([disabled]) *,
:host([disabled]) ::slotted(*) {
  pointer-events: none;
}

:host {
  display: block;
  cursor: pointer;
}
:host .container {
  position: relative;
  outline: 2px solid transparent;
  outline-offset: 2px;
}
:host .radio {
  cursor: pointer;
  border-radius: 9999px;
  background-color: var(--calcite-color-foreground-1);
  outline-color: transparent;
  transition: background-color, block-size, border-color, box-shadow, color, inset-block-end, inset-block-start, inset-inline-end, inset-inline-start inset-size, opacity, outline-color, transform var(--calcite-animation-timing) ease-in-out 0s, outline 0s, outline-offset 0s;
  box-shadow: inset 0 0 0 1px var(--calcite-color-border-input);
}

:host([hovered]) .radio,
:host(:not([checked])[focused]:not([disabled])) .radio {
  box-shadow: inset 0 0 0 2px var(--calcite-color-brand);
}

:host([focused]) .radio {
  outline: 2px solid var(--calcite-ui-focus-color, var(--calcite-color-brand));
  outline-offset: calc(
            2px *
            calc(
              1 -
              2 * clamp(
                0,
                var(--calcite-offset-invert-focus),
                1
              )
            )
          );
}

:host([disabled]) .radio {
  cursor: default;
  opacity: var(--calcite-opacity-disabled);
}
:host([disabled]) ::slotted([calcite-hydrated][disabled]),
:host([disabled]) [calcite-hydrated][disabled] {
  /* prevent opacity stacking */
  opacity: 1;
}

.interaction-container {
  display: contents;
}

:host([hovered][disabled]) .radio {
  box-shadow: inset 0 0 0 1px var(--calcite-color-border-input);
}

:host([scale=s]) {
  --calcite-radio-size: var(--calcite-font-size--2);
}

:host([scale=m]) {
  --calcite-radio-size: var(--calcite-font-size--1);
}

:host([scale=l]) {
  --calcite-radio-size: var(--calcite-font-size-0);
}

.radio {
  block-size: var(--calcite-radio-size);
  max-inline-size: var(--calcite-radio-size);
  min-inline-size: var(--calcite-radio-size);
}

:host([scale=s][checked]) .radio,
:host([hovered][scale=s][checked][disabled]) .radio {
  box-shadow: inset 0 0 0 4px var(--calcite-color-brand);
}

:host([scale=s][focused][checked]:not([disabled])) .radio {
  box-shadow: inset 0 0 0 4px var(--calcite-color-brand), 0 0 0 2px var(--calcite-color-foreground-1);
}

:host([scale=m][checked]) .radio,
:host([hovered][scale=m][checked][disabled]) .radio {
  box-shadow: inset 0 0 0 5px var(--calcite-color-brand);
}

:host([scale=m][focused][checked]:not([disabled])) .radio {
  box-shadow: inset 0 0 0 5px var(--calcite-color-brand), 0 0 0 2px var(--calcite-color-foreground-1);
}

:host([scale=l][checked]) .radio,
:host([hovered][scale=l][checked][disabled]) .radio {
  box-shadow: inset 0 0 0 6px var(--calcite-color-brand);
}

:host([scale=l][focused][checked]:not([disabled])) .radio {
  box-shadow: inset 0 0 0 6px var(--calcite-color-brand), 0 0 0 2px var(--calcite-color-foreground-1);
}

@media (forced-colors: active) {
  :host([checked]) .radio::after,
  :host([checked][disabled]) .radio::after {
    content: "";
    inline-size: var(--calcite-radio-size);
    block-size: var(--calcite-radio-size);
    background-color: windowText;
    display: block;
  }
}
::slotted(input[slot=hidden-form-input]) {
  margin: 0 !important;
  opacity: 0 !important;
  outline: none !important;
  padding: 0 !important;
  position: absolute !important;
  inset: 0 !important;
  transform: none !important;
  -webkit-appearance: none !important;
  z-index: -1 !important;
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}